import { userReportService } from "../../helpers/userReportService";

export const state = {
  getShowUserVehicle: [],
  getAllUserVehicle: [],
  getShowReportTitle: [],
  getShowVehicleModel: [],
  getUpdateStatus: [],
  getAllMake: [],
  getAllModel: [],
  getAllReportTitle: [],
  getAllUserReport: [],
  getAllVehicleModel: [],
  userVehicleCount: "",
  userReportCount: "",
  vehicleModelCount: "",
  reportTitleCount: "",
  paginations: {},
  loading: true,
};

export const mutations = {
  getAllUserReport(state, payload) {
    state.getAllUserReport = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.userReportCount = payload.result.total;
  },
  getAllReportTitle(state, payload) {
    state.getAllReportTitle = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.reportTitleCount = payload.result.total;
  },
  getShowReportTitle(state, payload) {
    state.getShowReportTitle = payload.result;
    state.loading = false;
  },
  getUserReportListRequest(state) {
    state.loading = true;
  },
  getUpdateStatus(state, payload) {
    state.getUpdateStatus = payload;
  },
  getUserReportListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getUserReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    console.log(data);
    commit("getUserReportListRequest");
    await userReportService.getUserReport(data).then(
      (response) => {
        commit("getAllUserReport", response.data);
      },
      (error) => {
        commit("getUserReportListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getReportTitle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserReportListRequest");
    await userReportService.getReportTitle(data).then(
      (response) => {
        commit("getAllReportTitle", response.data);
      },
      (error) => {
        commit("getUserReportListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async createReportTitle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserReportListRequest");
    await userReportService.addReportTitle(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUserReportListFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async showReportTitle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserReportListRequest");
    await userReportService.showReportTitle(data).then(
      (response) => {
        commit("getShowReportTitle", response.data);
      },
      (error) => {
        commit("getUserReportListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async updateReportTitle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserReportListRequest");
    await userReportService.updateReportTitle(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUserReportListFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async deleteReportReason({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await userReportService.deleteReportReason(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUserReportListFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllUserReport: (state) => state.getAllUserReport,
  getAllReportTitle: (state) => state.getAllReportTitle,
  reportTitleCount: (state) => state.reportTitleCount,
  userReportCount: (state) => state.userReportCount,
  pagination: (state) => state.paginations,
  getUpdateStatus: (state) => state.getUpdateStatus,
  getShowReportTitle: (state) => state.getShowReportTitle,
};
